import centerOfMass from '@turf/center-of-mass';
import type { FeatureCollection } from 'geojson';

export class FeatureCollectionToCenterOfMass {
  public static transform(featureCollection: FeatureCollection): FeatureCollection {
    return {
      type: 'FeatureCollection',
      features: featureCollection.features.map((feature) => {
        if (feature.geometry.type !== 'Point') {
          return {
            ...feature,
            properties: {
              ...feature.properties,
              originalGeometry: feature.geometry,
            },
            geometry: centerOfMass(feature.geometry).geometry,
          };
        }

        return feature;
      }),
    };
  }

  public static async fetch(url: string) {
    const data: FeatureCollection = await (await fetch(url)).json();

    return FeatureCollectionToCenterOfMass.transform(data);
  }
}
